// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  width: 100%;
}

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

body.fontLoaded {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#app {
  background-color: #f9f9f9;
  min-height: 100%;
  min-width: 100%;
  width: 100%;
  height: auto;
  display: flex;
  /* flex-grow: 1; */
  flex-direction: column;
  /* padding-bottom: 70px; */
}

/* @media only screen and (max-width: 600px) {
  #app {
    padding-bottom: 0px;
  }
} */

p,
label {
  font-family: Georgia, Times, 'Times New Roman', serif;
  line-height: 1.5em;
}

.pulsate-fwd {
  -webkit-animation: pulsate-fwd 5s ease-in-out infinite both;
  animation: pulsate-fwd 5s ease-in-out infinite both;
}

@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
}

@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
}

.warning {
  color: #856404 !important;
  background-color: #fff3cd;
  z-index: 100;
}

.danger {
  color: #721c24 !important;
  background-color: #f8d7da;
}

.success {
  color: #155724 !important;
  background-color: #d4edda;
  z-index: 100;
}

.secondary {
  color: #383d41 !important;
  background-color: #e2e3e5;
}

.primary {
  color: #004085 !important;
  background-color: #cce5ff;
}

.info {
  color: #0c5460 !important;
  background-color: #d1ecf1;
}

.recharts-cartesian-axis-tick {
  /* font-size: 1rem; */
  font-family: Roboto, sans-serif;
}

.recharts-rectangle > * {
  /* font-size: 1rem; */
  font-family: Roboto, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./app/app.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;;;GAIG;;AAEH;;EAEE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,mDAAmD;AACrD;;AAEA;EACE;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC","sourcesContent":["html,\nbody {\n  height: 100%;\n  width: 100%;\n}\n\nbody {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\nbody.fontLoaded {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n#app {\n  background-color: #f9f9f9;\n  min-height: 100%;\n  min-width: 100%;\n  width: 100%;\n  height: auto;\n  display: flex;\n  /* flex-grow: 1; */\n  flex-direction: column;\n  /* padding-bottom: 70px; */\n}\n\n/* @media only screen and (max-width: 600px) {\n  #app {\n    padding-bottom: 0px;\n  }\n} */\n\np,\nlabel {\n  font-family: Georgia, Times, 'Times New Roman', serif;\n  line-height: 1.5em;\n}\n\n.pulsate-fwd {\n  -webkit-animation: pulsate-fwd 5s ease-in-out infinite both;\n  animation: pulsate-fwd 5s ease-in-out infinite both;\n}\n\n@-webkit-keyframes pulsate-fwd {\n  0% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n}\n\n@keyframes pulsate-fwd {\n  0% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n}\n\n.warning {\n  color: #856404 !important;\n  background-color: #fff3cd;\n  z-index: 100;\n}\n\n.danger {\n  color: #721c24 !important;\n  background-color: #f8d7da;\n}\n\n.success {\n  color: #155724 !important;\n  background-color: #d4edda;\n  z-index: 100;\n}\n\n.secondary {\n  color: #383d41 !important;\n  background-color: #e2e3e5;\n}\n\n.primary {\n  color: #004085 !important;\n  background-color: #cce5ff;\n}\n\n.info {\n  color: #0c5460 !important;\n  background-color: #d1ecf1;\n}\n\n.recharts-cartesian-axis-tick {\n  /* font-size: 1rem; */\n  font-family: Roboto, sans-serif;\n}\n\n.recharts-rectangle > * {\n  /* font-size: 1rem; */\n  font-family: Roboto, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
